import { NgModule } from '@angular/core';
import { DowntimeReasonComponent } from './containers/downtime-reason.component';
import { SharedModule } from '@bd/shared/shared.module';

@NgModule({
  declarations: [DowntimeReasonComponent],
  imports: [SharedModule]
})
export class DowntimeReasonModule {}
